import React from 'react';
import { useSelector } from 'react-redux';
import { Popover } from '@milanote/roma';

import LabelsSearchBar from '../components/LabelsSearchBar';
import LabelLists from '../components/LabelLists';
import type { LabelsToolController } from '../hooks/labelsToolTypes';
import { getPlatformDetailsSelector } from '../../../../../../platform/platformSelector';
import { isPlatformTablet } from '../../../../../../platform/utils/platformDetailsUtils';

type LabelsToolbarPopupContentFrameProps = {
    controller: LabelsToolController;
};

/**
 * Shared desktop picker content for element and task-item label controllers.
 */
const GenericLabelsToolbarPopupContent: React.FC<LabelsToolbarPopupContentFrameProps> = ({ controller }) => {
    const platformDetails = useSelector(getPlatformDetailsSelector);
    const shouldAutoFocusSearch = !isPlatformTablet(platformDetails);
    const {
        allLabels,
        selectedLabelIds,
        hasCompletedInitialFetch,
        searchString,
        setSearchString,
        handleCreateLabel,
        handleSearchSubmit,
        handleToggleLabelSelection,
    } = controller;

    return (
        <div className="LabelsToolbarPopupContent">
            <LabelsSearchBar
                value={searchString}
                onChange={setSearchString}
                handleSearchSubmit={handleSearchSubmit}
                autoFocus={shouldAutoFocusSearch}
            />
            <Popover.Body className="max-h-[38rem] pb-1.5">
                <LabelLists
                    handleToggleLabelSelection={handleToggleLabelSelection}
                    handleCreateLabel={handleCreateLabel}
                    selectedLabelIds={selectedLabelIds}
                    searchString={searchString}
                    allLabels={allLabels}
                    hasCompletedInitialFetch={hasCompletedInitialFetch}
                />
            </Popover.Body>
        </div>
    );
};

export default GenericLabelsToolbarPopupContent;
